import isEmpty from 'lodash/isEmpty';
import React, { useContext, useEffect, useMemo, type JSX } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { StepControlPanel, StepPreview } from '@/shared/ui';
import { AddressBlock, addressBlockPreview } from '@/shared/ui/AddressBlock';
import { UkrainianAddressSchema } from '@/shared/ui/AddressBlock/model';

import { IdConstants } from '@/components/Forms/constants';

import AuthContext from '@/contexts/Auth/AuthContext';

import { ResidenceAddressSchema } from '../../model/types';

export const ResidenceAddress: React.FC<StepProps> = ({ next, prev }) => {
  const { control, getValues, setValue } = useFormContext<ResidenceAddressSchema>();
  const {
    addressesData: { LIVING },
  } = useContext(AuthContext);

  const registrationFormAddress = useMemo<Partial<UkrainianAddressSchema>>(
    () =>
      ({
        country: LIVING.country,
        region: LIVING.region,
        district: LIVING.district,
        settlement: LIVING.settlement,
        street: LIVING.street,
        house: LIVING.house,
        building: LIVING.building,
        apartment: LIVING.apartment,
        zip_code: null,
      }) as Partial<UkrainianAddressSchema>,
    [LIVING],
  );

  const isUkraine = registrationFormAddress.country?.id === IdConstants.UKRAINE;

  useEffect(() => {
    const formData = getValues();
    if (isEmpty(formData.residenceAddress) && Object.values(registrationFormAddress).some(Boolean) && isUkraine) {
      // @ts-ignore
      setValue('residenceAddress', registrationFormAddress);
    }
  }, [registrationFormAddress]);

  return (
    <>
      <FormBlock title="Дані про фактичне проживання">
        <Controller
          name="residenceAddress"
          control={control}
          render={({ field, formState: { errors } }): JSX.Element => (
            <AddressBlock
              address={field.value || (isUkraine ? registrationFormAddress : {})}
              onlyUkraine
              revalidate={!isEmpty(errors)}
              includeZipCode
              handleAddressChange={(newAddress): void => {
                field.onChange(newAddress);
              }}
            />
          )}
        />
      </FormBlock>

      <StepControlPanel next={next} prev={prev} />
    </>
  );
};

export const ResidenceAddressPreview: React.FC = () => {
  const { getValues } = useFormContext<ResidenceAddressSchema>();
  const { residenceAddress } = getValues();

  return (
    <StepPreview
      title="Дані про фактичне проживання"
      data={addressBlockPreview({
        address: residenceAddress,
        includeZipCode: true,
      })}
    />
  );
};
